<template>
	<div class="priority d-flex align-center">
		<div class="d-flex mr-2" :class="className">
			<span class="dot"></span>
			<span class="dot"></span>
			<span class="dot"></span>
		</div>
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		className: String,
	},
};
</script>

<style lang="scss" scoped>
.priority {
	color: var(--v-grey-darken2);
}
.dot {
	margin-right: 2px;
	width: 5px;
	height: 5px;
	background-color: var(--v-grey-lighten3);
	border-radius: 100%;
}
.none-priority {
	.dot {
		display: none;
	}
}
.low-priority {
	.dot:first-child {
		background-color: $color-green;
	}
}
.medium-priority {
	.dot:first-child,
	.dot:nth-child(2) {
		background-color: $color-yellow;
	}
}
.high-priority {
	.dot {
		background-color: $color-red;
	}
}
</style>
